// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productPartNumbersStyles } from "@stoneage/Overrides/Components/ProductPartNumbers";
import { TypographyProps } from "@insite/mobius/Typography";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { fontConfig } from "@stoneage/XDL/constants";
import { css } from "styled-components";

export const partNumbersStyle: { label?: TypographyProps; value?: TypographyProps } = {
    label: {
        ...fontConfig.xSmallSingleLine,
        weight: fontConfig.weight.regular,
        css: css`
            letter-spacing: 0;
            padding-left: 0;
            margin-right: 4px;
            white-space: nowrap;
            &:after {
                content: ":";
            }
        `,
    },
    value: {
        ...fontConfig.xSmallSingleLine,
        weight: fontConfig.weight.medium,
        css: css`
            letter-spacing: 0;
            min-width: 0;
            ${wrapInContainerStyles}
        `,
    },
};

productPartNumbersStyles.erpNumberGridItem =
    productPartNumbersStyles.customerNameGridItem =
    productPartNumbersStyles.manufacturerItemGridItem =
    productPartNumbersStyles.serialNumberGridItem =
        {
            css: css`
                display: flex;
            `,
        };

productPartNumbersStyles.erpNumberLabelText =
    productPartNumbersStyles.customerNameLabelText =
    productPartNumbersStyles.manufacturerItemLabelText =
    productPartNumbersStyles.serialNumberLabelText =
        {
            ...partNumbersStyle.label,
        };

productPartNumbersStyles.erpNumberValueText =
    productPartNumbersStyles.customerNameValueText =
    productPartNumbersStyles.manufacturerItemValueText =
    productPartNumbersStyles.serialNumberValueText =
        {
            ...partNumbersStyle.value,
        };
